module.exports = __webpack_public_path__ + "static/loading-d06826e9614c990e6f62ac3e41ea2d58.gif";